import { HiverAxios } from 'h-commons';
import { 
    FETCH_CONNECTOR_CHANNELS_INIT,
    FETCH_CONNECTOR_CHANNELS_DONE,
    FETCH_CONNECTOR_CHANNELS_FAILED,
    typePrefixMap
} from './types';
/**
 * transform channels data to redux store format
 * @param  {Object} data       
 */
const transformChannels = data => data
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(({ name, is_private }) => ({
        label: name,
        value: name,
        is_private
    }));
/**
 * redux async action to retrieve channels for a connector
 * @param  {string} type         Connector Type
 * @param  {string|number} smid  Shared Mailbox Id  
 */
export const getConnectorChannels = (type, smid, payload) => dispatch => {
    if (!(type in typePrefixMap)) {
        dispatch({
            type: FETCH_CONNECTOR_CHANNELS_FAILED,
            error: 'Unsupported Connector'
        });
        return;
    }
    dispatch({
        type: FETCH_CONNECTOR_CHANNELS_INIT,
        payload: payload || true
    });
    const prefix = typePrefixMap[type];
    HiverAxios({
        url: `${prefix}/get_channels?smid=${smid}`,
        type: 'get',
        callback: resp => {
            if (resp.data && resp.data.channels) {
                const selectOptions = transformChannels(resp.data.channels);
                dispatch({
                    type: FETCH_CONNECTOR_CHANNELS_DONE,
                    payload: { selectOptions, smid, type }
                });
            } else
                dispatch({
                    type: FETCH_CONNECTOR_CHANNELS_FAILED,
                    error: 'Something wrong happened'
                });
        },
        onfail: err => {
            dispatch({
                type: FETCH_CONNECTOR_CHANNELS_FAILED,
                error: err
            });
        }
    });
}